import { z } from "zod";

// All 4 screening questions are independently optional — a provider may
// submit an addendum having only touched one of them, leaving the rest
// untouched (null, same "unanswered" starting state as the note form
// itself). The comment is always required though — the backend rejects
// create_note_addendum with a 400 if `addendum` is empty, regardless of
// how many screening questions are answered.
const nullableBoolean = z.boolean().nullable().optional();

export const acaAddendumSchema = z.object({
  active_substance: nullableBoolean,
  activity_difficulties: nullableBoolean,
  acute_episode: nullableBoolean,
  addendum: z.string().min(1, "This is a required field."),
  sdoh: nullableBoolean,
});

export type AcaAddendumFormValues = z.infer<typeof acaAddendumSchema>;
